import {useSelector} from 'react-redux';
import {makeSelectTabOperations} from 'redux/store/auth';
import {NavTabsEnum} from 'utils/constants';

/**
 * True when the current admin may access the Customer Support tab:
 *   • SUPERADMIN / ADMIN → FULL_ACCESS (always true)
 *   • custom role        → only if granted the CUSTOMER_SUPPORT tab
 *   • no grant           → false
 *
 * Gates the global ticket-alerts watcher: admins without support access never
 * fetch or beep in the background.
 */
export const useHasSupportAccess = () => {
  const ops = useSelector(state =>
    makeSelectTabOperations(state, NavTabsEnum.CustomerSupport),
  );
  return !!ops?.view;
};
